<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline flex-row">
        <label>School Name:</label>
        <div class="input-group">
          <input
            type="text"
            placeholder="School Name"
            v-model="editSchoolName"
          />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Location:</label>
        <div class="input-group">
          <input type="text" placeholder="Location" v-model="editLocation" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>From:</label>
        <VueCtkDateTimePicker
          v-model="editStartTime"
          :max-date="editEndTime"
          :no-label="false"
          :only-date="true"
          :auto-close="true"
          :no-value-to-custom-elem="true"
          :right="true"
          format="YYYY-MM-DD"
          formatted="ll"
        >
          <input
            type="text"
            id="startTime"
            :value="editStartTime"
            placeholder="Select Date"
          />
        </VueCtkDateTimePicker>
      </div>
      <div class="form-inline flex-row">
        <label>To:</label>
        <div>
          <VueCtkDateTimePicker
            v-model="editEndTime"
            :min-date="editStartTime"
            :no-label="false"
            :only-date="true"
            :auto-close="true"
            :no-value-to-custom-elem="true"
            :right="true"
            format="YYYY-MM-DD"
            formatted="ll"
          >
            <input type="text" :value="editEndTime" placeholder="Select Date" />
          </VueCtkDateTimePicker>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Major:</label>
        <div class="input-group">
          <input type="text" placeholder="Major" v-model="editMajor" />
        </div>
      </div>
      <div class="form-inline">
        <label>Experiences:</label>
        <div
          class="input-group input-prepend input-append"
          v-for="(experience, index) in editExperiences"
          :key="index"
        >
          <textarea
            rows="3"
            placeholder="experience"
            v-model="editExperiences[index]"
          />
          <a
            href="javascript:void(0)"
            class="input-prepend-btn"
            @click="addExperience(index)"
          >
            <i class="material-icons-outlined align-middle">add</i>
          </a>
          <a
            href="javascript:void(0)"
            class="input-apend-btn"
            @click="deleteExperience(index)"
          >
            <i class="material-icons-outlined align-middle">delete</i>
          </a>
        </div>
      </div>
      <div class="form-inline flex-row">
        <button class="submit primary" @click="onButtonClick">
          {{ buttonLabel }}
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import { dateformat } from "@/utils/utils";
import moment from "moment";
export default {
  props: ["education", "type", "index"],
  components: { VueCtkDateTimePicker },
  watch: {
    education: function () {
      this.initData();
    },
    type: function () {
      this.initData();
    },
  },
  data() {
    return {
      panelTitle: null,
      buttonLabel: null,
      editSchoolName: null,
      editLocation: null,
      editStartTime: null,
      editEndTime: null,
      editMajor: null,
      editExperiences: null,
    };
  },
  created: function () {
    this.initData();
  },
  methods: {
    addExperience: function (index) {
      this.editExperiences.splice(index + 1, 0, "");
    },
    deleteExperience: function (index) {
      this.editExperiences.splice(index, 1);
      if (this.editExperiences.length == 0) {
        this.editExperiences.push("");
      }
    },
    initData: function () {
      if (this.type == "edit") {
        this.panelTitle = this.buttonLabel = "Edit Education";
        this.editSchoolName = this.education.school_name;
        this.editLocation = this.education.location;
        this.editStartTime = dateformat(
          this.education.start_time,
          "YYYY-MM-DD"
        );
        this.editEndTime = dateformat(this.education.end_time, "YYYY-MM-DD");
        this.editMajor = this.education.major;
        this.editExperiences = Object.assign([""], this.education.experiences);
      } else if (this.type == "add") {
        this.panelTitle = this.buttonLabel = "Add Education";
        this.editSchoolName =
          this.editLocation =
          this.editStartTime =
          this.editEndTime =
          this.editMajor =
            null;
        this.editExperiences = [""];
      }
    },
    onButtonClick: function () {
      const dataExperiences = [];
      this.editExperiences.forEach((item) => {
        if (item) {
          dataExperiences.push(item);
        }
      });
      const data = {
        school_name: this.editSchoolName ? this.editSchoolName : null,
        location: this.editLocation ? this.editLocation : null,
        start_time: this.editStartTime
          ? moment(this.editStartTime).valueOf() / 1000
          : null,
        end_time: this.editEndTime
          ? moment(this.editEndTime).valueOf() / 1000
          : null,
        major: this.editMajor ? this.editMajor : null,
        experiences: dataExperiences,
      };
      this.$emit("onButtonClick", data, this.type, this.index);
    },
  },
};
</script>
